export const removeAccents = (text) => {
	let result = text;
	result = result.replace(/[á]/g, 'a');
	result = result.replace(/[óöő]/g, 'o');
	result = result.replace(/[úüű]/g, 'u');
	result = result.replace(/[í]/g, 'i');
	result = result.replace(/[é]/g, 'e');
	result = result.replace(/[Á]/g, 'A');
	result = result.replace(/[ÓÖŐ]/g, 'O');
	result = result.replace(/[ÚÜŰ]/g, 'U');
	result = result.replace(/[Í]/g, 'I');
	result = result.replace(/[É]/g, 'E');
	return result;
};
